import { TTrainingEmployee } from '../types';

// Built-in demo audience for the training prototype: the 3 employees whose
// assigned function is Production or Quality Assurance - i.e. the people a real
// system would automatically identify from the document's target functions. Used
// as a fallback when the org config does not provide its own `employees` list.
export const DEFAULT_TRAINING_EMPLOYEES: TTrainingEmployee[] = [
  { id: 'emp-01', name: 'Anna Fischer', function: 'Production', included: true },
  { id: 'emp-02', name: 'Marco Bianchi', function: 'Production', included: true },
  { id: 'emp-03', name: 'Julia Weber', function: 'Quality Assurance', included: true },
];
